import React from "react";

interface PaginationProps {
    totalPages: number;
    currentPage: number;
    setCurrentPage: (page: number) => void;
}

const PaginationComponent: React.FC<PaginationProps> = ({ totalPages, currentPage, setCurrentPage }) => {
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);



    return (
        <div className="col-sm">
            <ul className="pagination custom-pagination pagination-sm pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                        className="page-link"
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        <i className="ri-arrow-left-s-line"></i>
                    </button>
                </li>

                {/* Page Numbers */}
                {pageNumbers.map((num) => (
                    <li key={num} className={`page-item ${currentPage === num ? "active" : ""}`}>
                        <button className="page-link" onClick={() => setCurrentPage(num)}>
                            {num}
                        </button>
                    </li>
                ))}

                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                        className="page-link"
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                       <i className="ri-arrow-right-s-line"></i>
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default PaginationComponent;
